import wrappedFetch from 'common/api/base';
import qs from 'qs';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';

const params = {
  method: 'POST',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
};

export const sendOtpToBrokerUser = async (userCredentials: object, isResendOtp: boolean, broker: string) => {
  const uri = `/${broker}/user_authenticator/send_otp`;
  const config = {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_credentials: userCredentials, is_resend_otp: isResendOtp }),
  };

  return wrappedFetch(uri, config)
    .then((response) => response.json())
    .then((result) => {
      return result;
    });
};

export const validatePinToBrokerUser = async (userCredentials: object, broker: string) => {
  const uri = `/${broker}/user_authenticator/validate_pin`;
  const config = {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_credentials: userCredentials }),
  };

  return wrappedFetch(uri, config)
    .then((response) => response.json())
    .then((result) => {
      return result;
    });
};

export const validateOtpToBrokerUser = async (userCredentials: object, broker: string) => {
  const uri = `/${broker}/user_authenticator/validate_otp`;
  const config = {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_credentials: userCredentials }),
  };

  return wrappedFetch(uri, config)
    .then((response) => response.json())
    .then((result) => {
      return result;
    });
};

export const validateBrokerUser = async (args: object) => {
  const queryParams = qs.stringify({ ...args });
  const uri = `/user/validate_broker_client?${queryParams}`;

  return wrappedFetch(uri, params)
    .then((response) => response.json())
    .then((result) => {
      return result;
    });
};

export const updateUserTheme = async () => {
  try {
    await wrappedFetch('/user/toggle_theme', { method: 'PUT' });
    setTimeout(() => {
      window.location.reload();
    }, 300);
  } catch (error) {
    console.error('Failed to toggle theme:', error);
    reactToastify('Failed to reset site tour. Please try again.', TOASTIFY_TYPES.ERROR);
  }
};
